import C from '../../ivy/Resume/Resume.module.scss';
import { Dispatch, SetStateAction, FocusEvent, useEffect, useRef, useState } from 'react';
import { SearchApiResponseType, SearchType } from '../../../types/EducationTypes';
import _ from 'lodash';
import {
  searchEnterprise,
  searchHighschool,
  searchLanguageQualification,
  searchMajor, searchNation,
  searchQualification,
  searchUniversity,
} from '../../../repository/EducationRepository';
import { AuthUtils } from '../../../utils/AuthUtils';

interface SearchDropdownProps {
  selectedSearchValue: string;
  setSelectedSearchValue: Function;
  type: SearchType;
  token: string;
  selectedValueIndex?: number;
  additionalType?: any;
}

const SearchDropdown = (props: SearchDropdownProps) => {
  const {
    selectedSearchValue,
    setSelectedSearchValue,
    type,
    token,
    selectedValueIndex,
    additionalType,
  } = props;
  const [inputText, setInputText] = useState<string>('');
  const [searchList, setSearchList] = useState<SearchApiResponseType[]>(
    [] as SearchApiResponseType[],
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const searchDropdownRef = useRef<HTMLDivElement>(null);
  const [isDropDownModal, setIsDropDownModal] = useState<boolean>(false);

  const [isFocused, setIsFocused] = useState<boolean>(false);
  let searchTimer: NodeJS.Timeout | null = null;
  const outSideClick = (e: any) => {
    const { target } = e;
    if (!inputRef.current?.contains(target) && !searchDropdownRef.current?.contains(target)) {
      setIsDropDownModal(false);
    }
  };

  const checkDropdownEnable = (value: string, searchNameList: SearchApiResponseType[]) => {
    if (_.isEmpty(value)) {
      setIsDropDownModal(false);
    } else {
      if (searchNameList !== null && searchNameList.length > 0) {
        setIsDropDownModal(true);
      } else {
        setIsDropDownModal(false);
      }
    }
  };

  const delayedSearchByType = (type: SearchType, keyword: string) => {
    // 이전에 설정된 타이머가 있다면 제거
    if (searchTimer) {
      clearTimeout(searchTimer);
    }

    // 0.5초 후에 API 호출
    searchTimer = setTimeout(() => {
      searchByType(type, keyword);
    }, 500);
  };

  const searchByType = (type: SearchType, keyword: string) => {
    let promise: Promise<any>;

    switch (type) {
      case 'high-school':
        promise = searchHighschool(token, keyword);
        break;
      case 'university':
        promise = searchUniversity(token, keyword, false);
        break;
      case 'graduate-school':
        promise = searchUniversity(token, keyword, true);
        break;
      case 'major':
        promise = searchMajor(token, keyword);
        break;
      case 'enterprise':
        promise = searchEnterprise(token, keyword);
        break;
      case 'qualification':
        promise = searchQualification(token, keyword);
        break;
      case 'language-qualification':
        promise = searchLanguageQualification(token, keyword);
        break;
      case 'nation':
        promise = searchNation(token, keyword);
        break;
      default:
        throw new Error('Invalid search type');
    }

    promise
      .then((res) => {
        setSearchList(res);
        checkDropdownEnable(keyword, res);
      })
      .catch((e) => console.error(e));
  };

  const getPlaceHolderText = (type: SearchType) => {
    switch (type) {
      case 'major':
        return '학과';
      case 'enterprise':
        return '회사명';
      case 'qualification':
        return '자격/면허종류';
      case 'language-qualification':
        return '시험명';
      case 'nation':
        return '국적선택 *';
      default:
        return '학교명';
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', outSideClick);

    if (!_.isEmpty(selectedSearchValue)) {
      setIsFocused(true);
    }

    return () => {
      document.removeEventListener('mousedown', outSideClick);
    };
  }, []);

  useEffect(() => {
    setInputText(selectedSearchValue);
  }, [selectedSearchValue]);

  useEffect(() => {
    AuthUtils.isLoggedInAndRedirect(token, 'login');
  }, [token]);

  return (
    <div className={`input-search-wrap ${C.search_bar}`}>
      <div className="input-grp">
        <label
          htmlFor={`${type}_searchValue_${selectedValueIndex}_${additionalType}`}
          className={
            isFocused ? 'input-label input-label-search focus-on' : 'input-label input-label-search'
          }
        >
          {getPlaceHolderText(type)}
        </label>
        <input
          type="search"
          id={`${type}_searchValue_${selectedValueIndex}_${additionalType}`}
          className="input-text input-border"
          ref={inputRef}
          value={inputText}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            if (_.isEmpty(selectedSearchValue)) {
              setInputText('');
              setIsFocused(false);
            } else {
              setInputText(selectedSearchValue);
              setIsFocused(true);
            }
          }}
          onChange={(e) => {
            setInputText(e.target.value);
            delayedSearchByType(type, e.target.value);
            if (type === 'university') {
              setSelectedSearchValue(selectedValueIndex, e.target.value);
            } else if (type === 'major') {
              setSelectedSearchValue(selectedValueIndex, e.target.value, additionalType);
            } else if (type === 'language-qualification') {
              setSelectedSearchValue(selectedValueIndex, e.target.value);
            }
            setIsFocused(true);
          }}
        />
      </div>

      <button className={`${C.search_icon}`}></button>
      <div className="validation"></div>
      {isDropDownModal && (
        <>
          <div className="auto-complete-result">
            {inputRef.current?.value !== '' && (
              <>
                <div className="search-result-list" ref={searchDropdownRef}>
                  <ul>
                    {searchList.map((s, index) => {
                      return (
                        <li key={`${type}-${s.name}`}>
                          <button
                            onClick={(e) => {
                              if (type === 'major') {
                                setSelectedSearchValue(
                                  selectedValueIndex,
                                  s.name,
                                  additionalType as string,
                                );
                              } else if (type === 'language-qualification') {
                                setSelectedSearchValue(
                                  selectedValueIndex,
                                  s.name,
                                  s.grades as string[],
                                );
                              } else if(type === 'nation') {
                                setSelectedSearchValue(
                                    selectedValueIndex,
                                    s.code
                                )
                              }else {
                                setSelectedSearchValue(selectedValueIndex, s.name);
                              }

                              if (inputRef.current) {
                                inputRef.current.value = s.name;
                              }
                              setIsDropDownModal(false);
                              setIsFocused(true);
                            }}
                          >
                            <span className="b2">{s.name}</span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchDropdown;
